<div class="page-wrapper">
  <app-preloader></app-preloader>
  <div [ngClass]="!isMobile() ? 'desktop-margin' : ''">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</div>
